import React from 'react'
import FiltrosBalance from './FiltrosBalance'

const FiltrosBalanceCuenta = () => {
  return (
    <>
      <div className='opciones cuenta'>
        <div>Selecciona: </div>
        <select>
          <option value="">Cuenta</option>
          <option value="Nomina">Nómina</option>
          <option value="Ahorro">Ahorro</option>
        </select>
        <select>
          <option value="">Concepto</option>
          <option value="Ingresos">Ingresos</option>
          <option value="Egresos">Egresos</option>
          <option value="Ahorros">Ahorros</option>
        </select>
      </div>
      <FiltrosBalance />
    </>
  )
}

export default FiltrosBalanceCuenta